import { Link, LinkProps } from '@mui/material';
import { OpensInNewTab } from '../OpensInNewTab/OpensInNewTab';

export type ExternalLinkProps = Omit<LinkProps, 'target' | 'rel'>;

export const ExternalLink = ({ children, ...props }: ExternalLinkProps) => (
  <Link target='_blank' rel='noopener noreferrer' {...props}>
    {children}
    <OpensInNewTab />
  </Link>
);
